<template>
    <div class="overlay"></div>
</template>

<script>
    export default {
        name: "Overlay"
    }
</script>

<style scoped>
    .overlay {
        position:absolute;
        width:100%;
        height:100%;
        z-index:99;
        background:#000;
        filter:opacity(70%);
    }
</style>
